// extracted by mini-css-extract-plugin
export default {"line":"Subtitle_line__09Szk","name":"Subtitle_name__2rLXX"};